import { createNode, PlainDateTimeDataType, ZonedDateTimeDataType } from '@glueapp/graph-types';
import { toPlainDateTime, fromZonedDateTime } from '../../utils/temporal';

export const DateTimeToZonedDateTime = createNode({
    id: 'DateTime to ZonedDateTime',
    name: 'DateTime to ZonedDateTime',
    description: 'Attaches a timezone to a DateTime, creating a ZonedDateTime',
    aiDescription:
        'Takes a DateTime on the "DateTime" port and a timezone string on the "Timezone" port, and outputs a ZonedDateTime on the "ZonedDateTime" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        DateTime: PlainDateTimeDataType,
        Timezone: { kind: 'string' },
    },
    outPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    execute: function (input) {
        const dateTime = toPlainDateTime(input.inPorts.DateTime);
        const zdt = dateTime.toZonedDateTime(input.inPorts.Timezone);
        return { output: { ZonedDateTime: fromZonedDateTime(zdt) } };
    },
});
